// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".emp-hdr-nav[data-v-d019fc1e]{width:100%;height:56px}.emp-hdr-nav__items[data-v-d019fc1e]{display:flex;align-items:center;width:100%;height:100%;padding-left:.25rem;padding-right:.25rem}.emp-hdr-nav__items .emp-hdr-nav__item[data-v-d019fc1e]{flex-shrink:0}", ""]);
// Exports
module.exports = exports;
